// Estruturas forçadas que o pipeline MEGA publica na EAP de toda obra, com orçamento zero:
// "ITENS SEM APROPRIAÇÃO" ancora o pago e o a pagar que o ERP não apropriou;
// "PEDIDOS E CONTRATOS SEM APROPRIAÇÃO" ancora o pedido e a linha de contrato sem vínculo
// confirmado com um serviço. São cadeias de um nó por nível, então as árvores da EAP não as
// abrem em células.
export const UNAPPROPRIATED_ITEMS_LABEL = 'ITENS SEM APROPRIAÇÃO'
export const UNAPPROPRIATED_ORDERS_CONTRACTS_LABEL = 'PEDIDOS E CONTRATOS SEM APROPRIAÇÃO'

const FORCED_UNIT_NAMES = new Set([UNAPPROPRIATED_ITEMS_LABEL, UNAPPROPRIATED_ORDERS_CONTRACTS_LABEL])

export const isForcedStructureUnit = (unit) => FORCED_UNIT_NAMES.has(String(unit?.building_unit_name ?? '').trim())

// Nó da estrutura de pedidos e contratos, em qualquer nível, pelo rótulo que o filtro de
// nível mostra (`building_unit_description` na unidade, `wbs_description` nos demais).
export const isUnappropriatedOrdersContractsNode = (node) => [
  node?.building_unit_name, node?.building_unit_description, node?.wbs_description, node?.description, node?.label,
].some((text) => String(text ?? '').includes(UNAPPROPRIATED_ORDERS_CONTRACTS_LABEL))
